<template>
	<div>
		<app-table
			class="is-not-selectable"
			name="dictionary"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="$emit('on-search', $event)"
			@on-page="$emit('on-page', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable col-1">
					{{ props.row.name }}
				</td>
				<td class="col-2">
					{{ props.row.code }}
				</td>
				<td class="col-5">
					<app-tooltip-button
						color="error"
						class="no-movil"
						img="/static/img/actions-list/delete.svg"
						text="Eliminar"
						@click-icon="$emit('on-delete', props.row)"
					/>
					<div class="collapse-menu">
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile class="menu-content" @click="$emit('on-delete', props.row)">
										<img
										src="/static/img/actions-list/delete.svg"
										alt="delete"
										class="menu-option-icon"
										width="15px"
										height="15px"
										>
										<span class="ml-1">Eliminar</span>
									</v-list-tile>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>

import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nombre', value: 'code', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Código', value: 'name', checked: true, visible: true },
			{ id: 5, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
	};
}

export default {
	name: 'report-list-asign',
	components: {
		appTooltipButton,
	},
	data,
	props: {
		currentPage: {
			default: 1,
			type: Number,
		},
		lastPage: {
			type: Number,
			default: 1,
		},
		rows: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss">
.col-1 {
	@media (max-width: 768px) {
		background-color: color(grey-background);
		display: grid;
		grid-column: 1/4;
		grid-row: 1;
		padding-left: 33px !important;
		text-align: left !important;
		white-space: nowrap;
	}
}

.col-2 {
	@media (max-width: 768px) {
		border-top: 1px solid color(grey-background);
		display: grid;
		grid-column: 1/2;
		grid-row: 2;
		line-height: 32px;
	}
}

.col-3 {
	@media (max-width: 768px) {
		display: grid;
		grid-column: 2/4;
		grid-row: 2;
		text-align: center !important;
	}
}

.col-4 {
	@media (max-width: 768px) {
		border-top: 1px solid color(grey-background);
		display: grid;
		grid-column: 4/5;
		grid-row: 2;
		padding-top: 7px;
		text-align: center !important;
	}
}

.col-5 {
	@media (max-width: 800px) {
		background-color: color(grey-background);
		display: grid;
		grid-column: 4/5;
		grid-row: 1;
		justify-content: center;
	}
}

.collapse-menu {
	display: none;

	@media (max-width: 780px) {
		align-items: center;
		display: block;
		height: 100%;
		justify-content: center;
	}

		.v-menu {
		align-items: center;
		display: flex;
		height: 100%;
		justify-content: center;

		.v-btn {
			background-color: color(btn-green);
			height: 25px;
			margin: 0;
			width: 25px;
		}
	}
}

	.menu-content {
		align-items: center;
		color: color(red-icon);
		display: grid;
		font-family: font(AvenirRegular);
		font-size: size(small) !important;
		grid-column-gap: 3px;
		grid-template-columns: 15px 1fr;
		width: 175px;

		.factory {
			color: color(secondary);
		}

		.edit {
			color: color(btn-green);
		}
	}

	.btn-menu-content {
		border-bottom: 1px solid color(grey-background-table);
	}
</style>



// WEBPACK FOOTER //
// src/components/reports-list/report-list-asign.vue